var _metadata, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAileronThinWebfont(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null)), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "aileronthin",
    horizAdvX: 1112
  }, /*#__PURE__*/React.createElement("fontFace", {
    unitsPerEm: 2048,
    ascent: 1577,
    descent: -471
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 393
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uFB01",
    horizAdvX: 876,
    d: "M49 1006v65h117v76q0 72 4 113q12 129 110.5 206.5t264.5 77.5q58 0 104 -10v-68q-192 23 -290.5 -38t-110.5 -173q-4 -41 -4 -104v-80h483v-1071h-78v1006h-405v-1006h-78v1006h-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uFB02",
    horizAdvX: 841,
    d: "M49 1006v65h96v76q0 62 5 113q12 131 93 207.5t226 76.5q123 0 199 -39v-1243q0 -100 2 -131q3 -51 28 -66.5t90 -7.5v-61q-25 -6 -75 -6q-55 0 -86.5 27.5t-34.5 93.5q-2 41 -2 149v1196q-45 23 -121 23q-115 0 -173.5 -63t-68.5 -161q-4 -41 -4 -104v-80h221v-65h-221 v-1006h-78v1006h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    horizAdvX: 682
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: " ",
    horizAdvX: 393
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\t",
    horizAdvX: 393
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA0",
    horizAdvX: 393
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "!",
    horizAdvX: 434,
    d: "M154 35q0 27 18 45t45 18q28 0 46 -17.5t18 -45.5t-18 -46t-46 -18q-27 0 -45 18.5t-18 45.5zM170 1413h94l-12 -1151h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\"",
    horizAdvX: 403,
    d: "M76 1505h80l-9 -501h-61zM258 1505h80l-8 -501h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "#",
    d: "M121 489v60h231l68 315h-238v62h250l105 487h61l-104 -487h217l104 487h62l-105 -487h219v-62h-231l-68 -315h238v-60h-250l-105 -489h-61l104 489h-217l-104 -489h-61l104 489h-219zM414 549h217l67 315h-217z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "$",
    d: "M106 373h82q17 -150 111.5 -236.5t243.5 -95.5v633q-83 23 -146.5 53t-118 76t-83.5 113t-29 153q0 161 106 260.5t271 110.5v157h63v-155q174 -9 273.5 -117t121.5 -274h-79q-17 146 -99 231t-217 92v-626q199 -59 297 -160.5t98 -255.5q0 -149 -106.5 -250.5 t-288.5 -110.5v-155h-63v155q-180 9 -300 113t-137 289zM250 1075q0 -69 21 -122t62.5 -89.5t91 -60.5t118.5 -45v614q-126 -10 -209.5 -87t-83.5 -210zM606 39q147 7 229.5 84t82.5 201q0 125 -76.5 206.5t-235.5 131.5v-623z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "%",
    horizAdvX: 1452,
    d: "M131 1114q0 144 73.5 235t198.5 91q124 0 198.5 -91.5t74.5 -234.5q0 -141 -74.5 -233.5t-198.5 -92.5q-125 0 -198.5 92t-73.5 234zM211 1114q0 -120 50 -191t142 -71q91 0 142 71.5t51 190.5q0 120 -51 191t-142 71q-92 0 -142 -70.5t-50 -191.5zM227 0l916 1413h84 l-916 -1413h-84zM778 297q0 144 74 235t199 91q124 0 198 -91.5t74 -234.5q0 -141 -74.5 -233.5t-197.5 -92.5q-125 0 -199 92.5t-74 233.5zM858 297q0 -120 50.5 -191t142.5 -71q91 0 141.5 71.5t50.5 190.5q0 120 -50.5 191t-141.5 71q-92 0 -142.5 -70.5t-50.5 -191.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "&",
    horizAdvX: 1318,
    d: "M141 332q0 155 102.5 254t272.5 123q-137 22 -220 107t-83 237q0 169 131.5 279t337.5 110q129 0 246 -21v-69q-115 22 -252 22q-166 0 -271.5 -85.5t-105.5 -231.5q0 -295 348 -312q39 -2 125 -2h201v291h78v-291h217v-69h-217v-668q-178 -35 -367 -35q-130 0 -225 16.5 t-169 56.5t-111.5 112t-37.5 176zM227 338q0 -166 115.5 -232.5t345.5 -66.5q170 0 285 22v613h-201q-84 0 -125 -4q-420 -36 -420 -332z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "'",
    horizAdvX: 210,
    d: "M55 1505h80l-10 -501h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "(",
    horizAdvX: 612,
    d: "M238 717q0 241 64.5 477t174.5 403h64q-112 -188 -174 -414.5t-62 -465.5q0 -238 62 -466t174 -415h-64q-110 167 -174.5 403.5t-64.5 477.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ")",
    horizAdvX: 612,
    d: "M68 -164q113 185 174 413t61 468q0 241 -61 467.5t-174 412.5h63q110 -167 175 -403t65 -477t-65 -477.5t-175 -403.5h-63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "*",
    horizAdvX: 1101,
    d: "M182 637l21 63l323 -118l-10 389h70l-11 -389l324 118l21 -63l-328 -100l231 -301l-55 -39l-217 313l-217 -313l-55 39l231 301z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "+",
    d: "M141 618v62h383v442h64v-442h383v-62h-383v-440h-64v440h-383z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ",",
    horizAdvX: 344,
    d: "M-18 -240l110 328h82l2 -12l-125 -316h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "-",
    horizAdvX: 561,
    d: "M66 547v61h430v-61h-430z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ".",
    horizAdvX: 344,
    d: "M80 35q0 27 18 45t45 18q28 0 46 -17.5t18 -45.5t-18 -46t-46 -18q-27 0 -45 18.5t-18 45.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "/",
    horizAdvX: 559,
    d: "M-10 -61l514 1536h65l-514 -1536h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 0,
    d: "M76 707q0 166 26 296.5t81.5 230.5t149.5 154t222 54q103 0 184.5 -36t136.5 -100t90.5 -157t51.5 -202t16 -240t-16 -240.5t-51.5 -202.5t-90.5 -157t-136.5 -100t-184.5 -36q-128 0 -222 54.5t-149.5 155.5t-81.5 231.5t-26 294.5zM162 707q0 -149 21 -267t66 -210 t122.5 -141.5t183.5 -49.5q393 0 393 668q0 667 -393 667t-393 -667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 1,
    d: "M276 1092v84l320 200q61 37 102 37h45v-1413h-77v1329z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 2,
    d: "M92 0v49l496 488q188 185 257.5 292.5t69.5 221.5q0 140 -85.5 231.5t-237.5 91.5q-153 0 -250.5 -96.5t-114.5 -263.5l-2 -21h-78l3 21q20 197 141 312.5t305 115.5q194 0 299.5 -109t105.5 -276q0 -132 -83.5 -258t-276.5 -312l-432 -419h799v-68h-916z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 3,
    d: "M92 418h78l2 -21q18 -164 118.5 -261t264.5 -97q169 0 276 89.5t107 248.5q0 143 -100.5 227t-302.5 84h-35v68h35q94 0 178.5 37t141 112.5t56.5 173.5q0 143 -88 219t-229 76q-150 0 -247 -88.5t-114 -247.5l-2 -20h-77l2 20q19 188 139.5 296t304.5 108q187 0 292 -99 t105 -256q0 -127 -81 -223.5t-207 -126.5q150 -29 232.5 -118.5t82.5 -239.5q0 -124 -63.5 -217.5t-170 -142t-239.5 -48.5q-194 0 -315 108.5t-142 317.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 4,
    d: "M49 397v45l739 971h70v-948h197v-68h-197v-397h-78v397h-731zM152 465h628v838q-61 -95 -168 -232z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 5,
    d: "M106 387h78l2 -20q19 -149 112.5 -238.5t246.5 -89.5q75 0 142.5 24.5t122 72t86.5 124.5t32 174q0 180 -99 287.5t-260 107.5q-252 0 -360 -227h-76l125 805h737v-68h-671l-105 -630l80 98q126 90 281 90q202 0 318 -129t116 -330q0 -108 -38 -197t-103 -147.5 t-149.5 -90.5t-178.5 -32q-174 0 -294.5 99.5t-141.5 296.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 6,
    d: "M88 618q0 214 36.5 373.5t104.5 257.5t159.5 145.5t207.5 47.5q348 0 412 -365l4 -20h-80l-4 20q-31 151 -113.5 224t-220.5 73q-70 0 -128 -18.5t-113.5 -68t-94 -129t-64 -208.5t-28.5 -299l51 111q133 180 361 180q142 0 246.5 -66.5t156 -175.5t51.5 -245 q0 -206 -134 -345t-343 -139q-467 0 -467 647zM180 477q0 -189 101 -313.5t276 -124.5q174 0 281.5 117.5t107.5 292.5q0 187 -102 306t-277 119q-163 0 -275 -111.5t-112 -285.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 7,
    d: "M94 1346v67h944v-37l-735 -1376h-86l721 1346h-844z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 8,
    d: "M82 369q0 136 84 234t225 134q-113 34 -177 122t-64 212q0 162 112.5 266.5t308.5 104.5q200 0 310 -104t110 -267q0 -123 -68.5 -212t-183.5 -120q138 -37 213.5 -134.5t75.5 -235.5q0 -128 -67.5 -220.5t-172.5 -136t-233 -43.5q-207 0 -340 104t-133 296zM168 367 q0 -81 32.5 -145t87.5 -104t124 -60.5t147 -20.5q100 0 185 35t141.5 111.5t56.5 183.5q0 149 -97 241t-282 92q-187 0 -291 -93t-104 -240zM236 1071q0 -74 27.5 -133t74.5 -95.5t106.5 -55.5t126.5 -19q91 0 165.5 32t122.5 102.5t48 168.5q0 138 -90.5 220.5t-245.5 82.5 t-245 -82.5t-90 -220.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 9,
    d: "M80 958q0 207 133.5 345.5t341.5 138.5q469 0 469 -647q0 -412 -135.5 -618t-372.5 -206q-347 0 -414 367l-2 20h80l4 -20q60 -299 336 -299q406 0 424 719l-51 -107q-130 -180 -358 -180q-142 0 -247 67t-156.5 176t-51.5 244zM166 965q0 -186 102 -306t277 -120 q163 0 274 111.5t111 285.5q0 123 -43 221.5t-129 157.5t-203 59q-175 0 -282 -116.5t-107 -292.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ":",
    horizAdvX: 344,
    d: "M80 35q0 27 18 45t45 18q28 0 46 -17.5t18 -45.5t-18 -46t-46 -18q-27 0 -45 18.5t-18 45.5zM80 1044q0 28 18 46t45 18q28 0 46 -18t18 -46q0 -26 -18.5 -44.5t-45.5 -18.5q-26 0 -44.5 18.5t-18.5 44.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ";",
    horizAdvX: 344,
    d: "M-18 -240l110 334h84v-14l-123 -320h-71zM80 1044q0 28 18 46t45 18q28 0 46 -18t18 -46q0 -26 -18.5 -44.5t-45.5 -18.5q-26 0 -44.5 18.5t-18.5 44.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "<",
    d: "M162 510v65l821 404v-74l-743 -360l743 -363v-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "=",
    d: "M125 430v59h860v-59h-860zM125 809v59h860v-59h-860z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ">",
    d: "M125 109v71l745 363l-745 360v76l821 -404v-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "?",
    horizAdvX: 1056,
    d: "M94 1012q8 192 128.5 311t307.5 119q190 0 296 -103.5t106 -263.5q0 -201 -197 -391q-127 -122 -165 -203t-40 -219h-73q3 153 41.5 238.5t167.5 214.5q96 98 138 181t42 179q0 138 -86 218.5t-230 80.5q-159 0 -251.5 -96.5t-104.5 -265.5h-80zM432 35q0 28 18 45.5 t46 17.5q27 0 45 -18t18 -45t-18.5 -45.5t-44.5 -18.5q-28 0 -46 18t-18 46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "@",
    horizAdvX: 1742,
    d: "M121 500q0 157 48.5 296t131 240.5t190.5 175.5t229 111t243 37q296 0 480.5 -187t184.5 -485q0 -130 -33 -234t-88 -168t-123 -98t-143 -34q-86 0 -144.5 44.5t-62.5 143.5l-37 -80q-105 -125 -237 -125q-48 0 -91 15t-83 49t-64 98.5t-24 153.5q0 141 56 263.5 t157 197.5t223 75q109 0 162 -67l34 -107l35 137h80l-108 -456q-23 -105 -23 -152q0 -61 36.5 -95t104.5 -34q128 0 217 127.5t89 337.5q0 288 -169.5 453t-439.5 165q-106 0 -214 -34t-206.5 -102t-174.5 -161.5t-121.5 -222.5t-45.5 -274q0 -157 51 -284t137.5 -207 t197.5 -122.5t235 -42.5q155 0 284 40.5t265 136.5l31 -56q-156 -106 -289 -144t-293 -38q-105 0 -204 27.5t-187 85.5t-154 140.5t-104.5 201t-38.5 258.5zM584 461q0 -129 51 -193.5t141 -64.5q97 0 176.5 88.5t120.5 265.5l19 82q29 125 -17.5 205t-142.5 80 q-93 0 -173 -62t-127.5 -169t-47.5 -232z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "A",
    horizAdvX: 1273,
    d: "M70 0l538 1413h103l532 -1413h-84l-203 539h-604l-198 -539h-84zM379 606h553l-275 744z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "B",
    horizAdvX: 1222,
    d: "M199 0v1413h370q96 0 166 -4q165 -14 260 -102.5t95 -235.5q0 -129 -70 -212.5t-193 -110.5q156 -29 236 -122.5t80 -240.5q0 -85 -31 -155t-84.5 -116.5t-122.5 -74t-147 -33.5q-57 -6 -150 -6h-409zM276 68h363q40 0 94 4q64 5 120.5 25t103.5 55.5t74.5 94t27.5 132.5 q0 65 -17.5 119t-54 99t-101 72t-151.5 31q-59 5 -108 5h-351v-637zM276 772h324q23 0 113 4q59 5 108.5 22.5t92.5 49.5t67.5 86.5t24.5 126.5q0 73 -25.5 128t-69.5 86.5t-96 48t-113 19.5q-67 3 -129 3h-297v-574z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "C",
    horizAdvX: 1398,
    d: "M102 702q0 215 84.5 384.5t232 262.5t331.5 93q118 0 214 -35t162 -97.5t108 -144t60 -180.5l2 -20h-77l-5 20q-35 175 -156.5 282t-314.5 107q-111 0 -210.5 -45.5t-176.5 -128.5t-122.5 -211t-45.5 -282q0 -161 42.5 -289.5t116 -210.5t170.5 -125t210 -43 q205 0 327 111.5t160 295.5l5 21h77l-2 -21q-18 -101 -61 -185t-111.5 -150t-170.5 -103t-228 -37q-278 0 -449.5 198.5t-171.5 532.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "D",
    horizAdvX: 1406,
    d: "M199 0v1413h413q101 0 158 -4q77 -7 152 -34t150 -82t131 -131.5t91 -192t35 -254.5q0 -137 -35 -253.5t-90 -194.5t-127.5 -135.5t-143.5 -86t-142 -37.5q-72 -8 -181 -8h-411zM276 68h330q98 0 174 10q70 9 135.5 38.5t125.5 83t104.5 125.5t71 173t26.5 217 q0 119 -28 220t-75 171t-109.5 121t-129.5 77.5t-137 34.5q-53 7 -154 7h-334v-1278z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "E",
    horizAdvX: 1157,
    d: "M199 0v1413h874v-65h-797v-609h750v-65h-750v-606h818v-68h-895z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "F",
    horizAdvX: 1105,
    d: "M199 0v1413h874v-65h-797v-609h730v-65h-730v-674h-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "G",
    horizAdvX: 1429,
    d: "M102 702q0 216 86 385t237 262t341 93q231 0 369 -126t174 -331l4 -20h-78l-4 20q-35 175 -156.5 282t-316.5 107q-114 0 -217 -45.5t-181.5 -128.5t-125 -211t-46.5 -282q0 -161 42.5 -289.5t116.5 -210.5t172.5 -125t213.5 -43q68 0 135 18t132.5 59.5t115.5 101.5 t80.5 152.5t30.5 204.5h-441v68h519v-643h-72v342l-47 -131q-78 -122 -198.5 -181t-260.5 -59q-281 0 -453 198.5t-172 532.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "H",
    horizAdvX: 1380,
    d: "M199 0v1413h77v-686h877v686h78v-1413h-78v659h-877v-659h-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "I",
    horizAdvX: 425,
    d: "M199 0v1413h77v-1413h-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "J",
    horizAdvX: 1038,
    d: "M100 465h78l2 -68q7 -186 95.5 -272t236.5 -86q141 0 222 83.5t93 237.5q4 43 4 164v889h78v-878q0 -115 -4 -183q-5 -78 -31 -145t-74 -120.5t-124.5 -84.5t-173.5 -31q-185 0 -289 108t-111 318z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "K",
    horizAdvX: 1161,
    d: "M199 0v1413h77v-751l781 751h96l-715 -686l697 -727h-113l-643 676l-103 -103v-573h-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "L",
    horizAdvX: 1122,
    d: "M199 0v1413h77v-1345h818v-68h-895z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "M",
    horizAdvX: 1662,
    d: "M199 0v1413h127l532 -1345l537 1345h118v-1413h-75v797q0 465 2 551q-106 -290 -213 -551l-322 -797h-98l-322 799q-131 324 -213 547q4 -172 4 -549v-797h-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "N",
    horizAdvX: 1345,
    d: "M199 0v1413h118l807 -1339q-4 184 -4 588v751h76l2 -1413h-121l-805 1339q4 -184 4 -585v-754h-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "O",
    horizAdvX: 1472,
    d: "M102 707q0 212 78.5 378.5t226.5 261.5t343 95q194 0 341.5 -95t225.5 -261.5t78 -378.5t-78 -378.5t-225.5 -262t-341.5 -95.5q-195 0 -343 95.5t-226.5 262t-78.5 378.5zM188 707q0 -155 44 -282.5t120.5 -211t178.5 -129t219 -45.5q116 0 217.5 45.5t177.5 129 t120 211t44 282.5q0 156 -44 283.5t-120 210.5t-177.5 128t-217.5 45q-117 0 -219 -45t-178.5 -128t-120.5 -210.5t-44 -283.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "P",
    horizAdvX: 1105,
    d: "M199 0v1413h344q115 0 198 -10q159 -20 254 -114t95 -265q0 -176 -96.5 -275.5t-252.5 -121.5q-74 -9 -198 -9h-267v-618h-77zM276 686h271q112 0 186 10q124 19 198.5 99t74.5 229q0 141 -74.5 217t-198.5 92q-74 10 -186 10h-271v-657z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Q",
    horizAdvX: 1474,
    d: "M102 707q0 212 78.5 378.5t226.5 261.5t343 95q194 0 341.5 -95t225.5 -261.5t78 -378.5q0 -436 -318 -633q84 -3 149 -32t140 -93l-45 -55q-84 62 -148 86t-139 24q-54 0 -139 -18q-73 -15 -145 -15q-195 0 -343 95.5t-226.5 262t-78.5 378.5zM188 707q0 -155 44 -282.5 t120.5 -211t178.5 -129t219 -45.5q116 0 217.5 45.5t177.5 129t120 211t44 282.5q0 156 -44 283.5t-120 210.5t-177.5 128t-217.5 45q-117 0 -219 -45t-178.5 -128t-120.5 -210.5t-44 -283.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "R",
    horizAdvX: 1193,
    d: "M199 0v1413h372q117 0 199 -10q165 -21 254.5 -109t89.5 -243q0 -134 -76.5 -224.5t-203.5 -117.5q90 -31 141.5 -117t64.5 -209q16 -145 38 -229t57 -154h-88q-30 83 -49 160t-35 211q-15 130 -75 211.5t-175 87.5q-43 2 -123 2h-314v-672h-77zM276 739h316q90 0 149 4 q133 11 211 91.5t78 209.5q0 255 -278 291q-78 11 -181 11h-295v-607z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "S",
    horizAdvX: 1159,
    d: "M86 377h82q23 -160 142.5 -249t287.5 -89q163 0 271 84t108 217q0 141 -87.5 215t-303.5 133q-115 31 -191.5 63t-133.5 77.5t-83 106t-26 142.5q0 158 130.5 261.5t315.5 103.5q193 0 306.5 -111.5t135.5 -286.5h-82q-23 156 -121 243t-245 87q-52 0 -103 -11 t-96.5 -34.5t-80.5 -56.5t-55.5 -80t-20.5 -102q0 -71 21 -120.5t71.5 -87.5t116 -64t173.5 -56q116 -31 195.5 -66.5t136.5 -84t84 -112t27 -147.5q0 -164 -132.5 -272.5t-332.5 -108.5q-135 0 -243 44t-180 137t-87 225z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "T",
    horizAdvX: 1204,
    d: "M68 1348v65h1140v-65h-532v-1348h-78v1348h-530z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "U",
    horizAdvX: 1271,
    d: "M186 489v924h78v-926q0 -65 6 -127q13 -143 110.5 -232t278.5 -89q183 0 281 89t111 232q6 62 6 127v926h78v-924q0 -35 -7 -135q-13 -173 -133 -278t-336 -105q-215 0 -334 105t-132 278q-7 100 -7 135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "V",
    horizAdvX: 1214,
    d: "M57 1413h84l502 -1350l504 1350h84l-537 -1413h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "W",
    horizAdvX: 1751,
    d: "M53 1413h86l330 -1339l383 1319h106l363 -1317l352 1337h80l-385 -1413h-100l-365 1317l-387 -1317h-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "X",
    horizAdvX: 1198,
    d: "M55 0l508 707l-471 706h88l432 -647l469 647h97l-521 -702l517 -711h-99l-463 655l-462 -655h-95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Y",
    horizAdvX: 1134,
    d: "M45 1413h90l455 -762l446 762h90l-501 -840v-573h-78v573z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Z",
    horizAdvX: 1128,
    d: "M80 0v59l895 1287h-838v67h928v-65l-891 -1280h903v-68h-997z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "[",
    horizAdvX: 634,
    d: "M254 -164v1761h317v-61h-254v-1638h254v-62h-317z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\\\\\\\",
    horizAdvX: 559,
    d: "M-10 1475h65l514 -1536h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "]",
    horizAdvX: 628,
    d: "M57 -102h256v1638h-256v61h320v-1761h-320v62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "^",
    d: "M168 440l354 822h76l350 -822h-71l-318 760l-319 -760h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "_",
    horizAdvX: 1024,
    d: "M102 -106h820v-62h-820v62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "`",
    horizAdvX: 614,
    d: "M135 1413h84l123 -225h-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "a",
    horizAdvX: 1030,
    d: "M90 266q0 121 88 204.5t230 121t327 37.5h70v49q0 92 -4 137q-9 110 -79.5 168.5t-197.5 58.5q-78 0 -142.5 -27t-111 -89t-57.5 -152h-80q11 146 119.5 240t271.5 94q165 0 254 -74t101 -211q4 -53 4 -141v-352q0 -124 18 -330h-80l-14 236l-51 -109 q-55 -77 -140 -116.5t-188 -39.5q-156 0 -247 76t-91 219zM176 270q0 -111 68.5 -172t201.5 -61q158 0 258.5 113t100.5 274v139q-46 3 -90 3q-72 0 -140 -8q-110 -13 -200.5 -46.5t-144.5 -96t-54 -145.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "b",
    horizAdvX: 1148,
    d: "M147 0v1505h78v-653l64 121q65 72 142.5 103.5t182.5 31.5q215 0 344 -155.5t129 -401.5q0 -141 -40.5 -253.5t-110 -182.5t-158.5 -107t-190 -37q-187 0 -301 123l-62 127v-221h-78zM225 475q0 -96 22 -173t57.5 -125.5t84 -81t97.5 -45.5t102 -13q183 0 298 138 t115 364q0 140 -44 252t-135 181.5t-216 69.5q-80 0 -146.5 -24.5t-120.5 -76.5t-84 -143.5t-30 -215.5v-107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "c",
    horizAdvX: 1064,
    d: "M61 539q0 129 40 237.5t108 180.5t158.5 111.5t191.5 39.5q178 0 295.5 -101.5t142.5 -269.5h-79q-28 145 -121.5 226t-241.5 81q-75 0 -146.5 -31t-130.5 -89.5t-95 -155.5t-36 -217q0 -127 33.5 -228t90 -162t127 -92.5t149.5 -31.5q134 0 232.5 76.5t127.5 214.5h80 q-33 -167 -154 -262t-292 -95q-100 0 -187 37.5t-152.5 108t-103 179.5t-37.5 243z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "d",
    horizAdvX: 1150,
    d: "M61 530q0 140 40.5 252t110.5 182t159 107t190 37q187 0 301 -123l62 -125v645h77v-1505h-77v229l-64 -123q-65 -72 -142.5 -103.5t-182.5 -31.5q-143 0 -251.5 71.5t-165.5 198t-57 289.5zM147 541q0 -103 26 -193.5t75 -160t125 -110t170 -40.5q64 0 118.5 15t104 49.5 t84 87t54.5 132t20 179.5v104q0 96 -22 173t-57.5 125.5t-84 81t-97.5 45.5t-102 13q-183 0 -298.5 -138t-115.5 -363z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "e",
    horizAdvX: 1081,
    d: "M61 543q0 126 38 232.5t104 179t156 113t192 40.5q111 0 199.5 -44.5t143 -120t83.5 -171.5t29 -203q0 -24 -2 -51h-861q4 -126 39.5 -222t92 -150.5t122.5 -81.5t140 -27q130 0 232 76t140 223h80q-43 -177 -168 -271t-289 -94q-98 0 -182.5 36.5t-149.5 106.5 t-102 180.5t-37 248.5zM143 586h783q-4 120 -38 211t-88.5 143t-118 77t-134.5 25q-72 0 -141 -28.5t-127 -83t-95 -144t-41 -200.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "f",
    horizAdvX: 501,
    d: "M49 1006v65h117v152q0 73 4 114q10 101 70 154t143 53q56 0 102 -10v-68q-43 10 -79 10q-54 0 -90 -24q-58 -38 -68 -121q-4 -41 -4 -104v-156h221v-65h-221v-1006h-78v1006h-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "g",
    horizAdvX: 1150,
    d: "M61 530q0 140 40.5 252t110.5 182t159 107t190 37q187 0 301 -123l62 -125v225h77v-802q0 -229 -2 -297q-6 -199 -127.5 -315.5t-332.5 -116.5q-87 0 -158.5 18.5t-129 57t-94.5 103.5t-48 154l-5 27h80l2 -27q18 -134 115.5 -200t241.5 -66q179 0 276.5 100.5 t102.5 270.5q2 68 2 201v36l-64 -123q-65 -72 -142.5 -103.5t-182.5 -31.5q-143 0 -251.5 71.5t-165.5 198t-57 289.5zM147 541q0 -103 26 -193.5t75 -160t125 -110t170 -40.5q64 0 118.5 15t104 49.5t84 87t54.5 132t20 179.5v104q0 96 -22 173t-57.5 125.5t-84 81 t-97.5 45.5t-102 13q-183 0 -298.5 -138t-115.5 -363z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "h",
    horizAdvX: 1118,
    d: "M147 0v1516h78v-668l49 113q118 147 324 147q166 0 263 -86.5t112 -241.5q8 -73 8 -178v-602h-78v584q0 101 -8 174q-13 133 -89 208q-75 74 -212 74h-4q-73 0 -137.5 -26.5t-116 -78t-81.5 -138.5t-30 -199v-598h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "i",
    horizAdvX: 374,
    d: "M127 1305q0 25 17 42t42 17t42.5 -17t17.5 -42t-17.5 -42.5t-42.5 -17.5t-42 17.5t-17 42.5zM147 0v1079h78v-1079h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "j",
    horizAdvX: 358,
    d: "M-55 -358q31 -5 56 -5q49 0 79 17q47 27 51 108q2 29 2 82v1235h78v-1214q0 -76 -2 -113q-6 -91 -57 -136.5t-134 -45.5q-32 0 -73 6v66zM115 1305q0 25 16 42t41 17t42 -17t17 -42t-17 -42.5t-42 -17.5q-24 0 -40.5 17.5t-16.5 42.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "k",
    horizAdvX: 970,
    d: "M147 0v1505h78v-999l602 573h107l-555 -520l559 -559h-111l-505 510l-97 -92v-418h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "l",
    horizAdvX: 393,
    d: "M141 260v1245h78v-1243q0 -100 2 -131q3 -51 28 -67q16 -10 51 -10q18 0 40 3v-61q-25 -6 -76 -6q-55 0 -86.5 27.5t-34.5 93.5q-2 41 -2 149z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "m",
    horizAdvX: 1681,
    d: "M147 0v1079h78v-211l54 119q103 121 272 121q128 0 207.5 -67.5t107.5 -192.5l72 139q103 121 270 121q144 0 226 -82t100 -233q8 -73 8 -179v-614h-78v580q0 113 -8 186q-14 131 -79.5 203.5t-184.5 72.5q-136 0 -221.5 -110.5t-85.5 -333.5v-598h-78v580q0 113 -8 186 q-16 131 -82 203.5t-185 72.5q-135 0 -221 -110.5t-86 -333.5v-598h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "n",
    horizAdvX: 1118,
    d: "M147 0v1079h78v-231l49 113q118 147 324 147q166 0 263 -86.5t112 -241.5q8 -73 8 -178v-602h-78v584q0 101 -8 174q-14 132 -89 207t-216 75q-73 0 -137.5 -26.5t-116 -78t-81.5 -138.5t-30 -199v-598h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "o",
    horizAdvX: 1150,
    d: "M61 539q0 254 139 411.5t375 157.5t375.5 -157.5t139.5 -411.5q0 -253 -139.5 -410.5t-375.5 -157.5t-375 157.5t-139 410.5zM147 539q0 -122 34.5 -219t94 -158t136 -93t163.5 -32t164 32t137 93t95 158.5t35 218.5q0 122 -35 219.5t-95 158.5t-137 93t-164 32 t-163.5 -32t-136 -93t-94 -158.5t-34.5 -219.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "p",
    horizAdvX: 1148,
    d: "M147 -401v1493h78v-240l64 121q65 72 142.5 103.5t182.5 31.5q215 0 344 -155.5t129 -401.5q0 -141 -40.5 -253.5t-110 -182.5t-158.5 -107t-190 -37q-187 0 -301 123l-62 127v-622h-78zM225 475q0 -96 22 -173t57.5 -125.5t84 -81t97.5 -45.5t102 -13q183 0 298 138 t115 364q0 140 -44 252t-135 181.5t-216 69.5q-80 0 -146.5 -24.5t-120.5 -76.5t-84 -143.5t-30 -215.5v-107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "q",
    horizAdvX: 1153,
    d: "M61 530q0 140 40.5 252t110.5 182t159 107t190 37q187 0 301 -123l64 -129v236h78v-1493h-78v634l-66 -127q-65 -72 -142.5 -103.5t-182.5 -31.5q-143 0 -251.5 71.5t-165.5 198t-57 289.5zM147 541q0 -103 26 -193.5t75 -160t125 -110t170 -40.5q64 0 118.5 15t104 49.5 t84 87t54.5 132t20 179.5l2 -23v141l-2 -14q0 96 -22 173t-57.5 125.5t-84 81t-97.5 45.5t-102 13q-183 0 -298.5 -138t-115.5 -363z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "r",
    horizAdvX: 563,
    d: "M147 0v1079h78v-219l58 131q84 117 219 117q31 0 55 -6v-64q-14 1 -28 1q-134 1 -215 -97q-89 -108 -89 -344v-598h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "s",
    horizAdvX: 903,
    d: "M53 319h80q45 -282 332 -282q123 0 205 58t82 161q0 102 -71 157.5t-253 98.5q-73 18 -126.5 40t-101.5 56t-73 85.5t-25 117.5q0 131 96 214t248 83q164 0 258 -89.5t117 -236.5h-80q-31 132 -104 196t-195 64q-111 0 -185.5 -61t-74.5 -164q0 -99 70 -150.5t209 -84.5 q193 -44 281.5 -117t88.5 -205q0 -133 -104 -211t-268 -78q-107 0 -191.5 34.5t-143 114.5t-71.5 199z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "t",
    horizAdvX: 522,
    d: "M53 1010v61h133v229h78v-229h209v-61h-209v-734q0 -79 2 -108q6 -80 50 -106q27 -15 79 -16q34 0 80 7v-61q-49 -6 -115 -6q-80 0 -122 37t-48 114q-4 45 -4 144v729h-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "u",
    d: "M129 469v610h78v-590q0 -97 8 -170q16 -131 92.5 -205.5t214.5 -74.5q154 0 258.5 112.5t104.5 329.5v598h78v-1079h-78v231l-49 -112q-124 -148 -324 -148q-162 0 -259 84.5t-116 233.5q-8 73 -8 180z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "v",
    horizAdvX: 983,
    d: "M20 1079h89l387 -1020l387 1020h84l-422 -1079h-103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "w",
    horizAdvX: 1501,
    d: "M20 1079h91l307 -1003l291 1001h102l293 -997l299 999h84l-342 -1079h-94l-291 997l-291 -997h-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "x",
    horizAdvX: 886,
    d: "M2 0l385 543l-369 536h93l325 -483l332 483h92l-381 -534l383 -545h-94l-334 492l-340 -492h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "y",
    horizAdvX: 964,
    d: "M20 1079h89l376 -1018l377 1018h88l-424 -1102q-48 -126 -91.5 -207.5t-87.5 -124.5t-84.5 -59t-94.5 -16q-42 0 -76 6v68q27 -6 76 -6q71 0 129.5 56t118.5 202l30 77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "z",
    horizAdvX: 919,
    d: "M31 0v61l735 936h-682v68h778v-66l-737 -936h745v-63h-839z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "{",
    horizAdvX: 610,
    d: "M154 686v62q86 8 125.5 58.5t39.5 125.5q0 79 -20 225q-25 164 -25 215q0 121 70 173t199 52h32v-61h-34q-99 0 -151 -37.5t-52 -124.5q0 -35 22 -196q23 -175 23 -248q0 -76 -39 -135t-123 -76q83 -19 122.5 -79t39.5 -136q0 -73 -23 -248q-22 -158 -22 -197 q0 -87 52 -124t151 -37h34v-62h-32q-129 0 -199 52t-70 173q0 54 25 215q20 146 20 226q0 75 -39.5 125.5t-125.5 58.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "|",
    horizAdvX: 512,
    d: "M225 -410v2048h64v-2048h-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "}",
    horizAdvX: 610,
    d: "M35 -102h35q99 0 150.5 37t51.5 124q0 39 -22 197q-23 175 -23 248q0 76 39 135t123 76q-83 19 -122.5 80t-39.5 135q0 73 23 248q22 161 22 196q0 87 -51.5 124.5t-150.5 37.5h-35v61h33q129 0 198.5 -52t69.5 -173q0 -51 -25 -215q-20 -146 -20 -225q0 -74 40 -125 t126 -59v-62q-86 -8 -126 -59t-40 -125q0 -80 20 -226q25 -161 25 -215q0 -121 -69.5 -173t-198.5 -52h-33v62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "~",
    d: "M125 467q0 248 188 248q58 0 106 -18t154 -76q91 -50 137.5 -68t90.5 -18q66 0 95.5 46.5t29.5 139.5h61q0 -248 -190 -248q-57 0 -106 17.5t-152 74.5q-93 51 -139 69.5t-91 18.5q-123 0 -123 -186h-61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA1",
    horizAdvX: 434,
    d: "M154 1051q0 27 18 45t45 18q28 0 46 -17.5t18 -45.5q0 -27 -18.5 -45.5t-45.5 -18.5q-26 0 -44.5 19t-18.5 45zM170 -328l12 1153h70l12 -1153h-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA2",
    horizAdvX: 1101,
    d: "M92 543q0 240 128.5 395t320.5 174v158h63v-156q172 -4 285.5 -105.5t136.5 -265.5h-80q-25 140 -113 221t-229 87v-1014q126 9 215.5 84.5t118.5 206.5h80q-32 -158 -143 -252t-271 -103v-157h-63v155q-196 11 -322.5 163t-126.5 409zM176 553q0 -120 30 -217t81.5 -159 t116 -97t137.5 -41v1010q-70 -10 -133.5 -46t-116 -95.5t-84 -151.5t-31.5 -203z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA3",
    d: "M119 0v63q130 34 213.5 126.5t83.5 228.5q0 71 -22.5 136t-71.5 148h-185v62h150q-88 159 -88 297q0 168 113.5 274.5t281.5 106.5q188 0 286 -109t111 -293h-82q-12 164 -92 249t-227 85q-129 0 -217 -86t-88 -217q0 -78 22.5 -146t73.5 -161h471v-62h-436 q82 -143 82 -276q0 -241 -238 -358h733v-68h-874z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA4",
    d: "M158 260l118 117q-83 99 -83 239q0 141 83 240l-118 119l47 45l117 -117q101 82 233 82q136 0 233 -84l119 119l47 -45l-118 -119q82 -101 82 -240q0 -138 -82 -239l118 -119l-47 -45l-116 119q-100 -84 -236 -84t-233 84l-117 -119zM262 616q0 -131 83 -219t210 -88 q128 0 211.5 88t83.5 219t-83.5 219.5t-211.5 88.5q-127 0 -210 -88.5t-83 -219.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA5",
    d: "M45 1413h100l412 -698l412 698h96l-432 -704h328v-62h-365l-2 -2v-151h367v-62h-367v-432h-78v432h-364v62h364v151l-2 2h-362v62h325z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA6",
    horizAdvX: 512,
    d: "M225 -328v697h64v-697h-64zM225 717v696h64v-696h-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA7",
    horizAdvX: 1101,
    d: "M92 578q0 125 73 203t193 108q-155 91 -155 254q0 137 95 218t247 81q163 0 257 -87.5t120 -236.5h-80q-65 258 -299 258q-108 0 -182 -59.5t-74 -163.5q0 -48 17.5 -87.5t46 -68t71.5 -51.5t88.5 -38t101.5 -27q426 -87 426 -357q0 -122 -75.5 -202t-196.5 -109 q164 -91 164 -276q0 -135 -106 -214t-269 -79q-343 0 -408 342h80q69 -277 334 -277q122 0 203.5 59.5t81.5 161.5q0 76 -30.5 127t-113 94.5t-229.5 75.5q-73 16 -138 44.5t-121 71t-89 103.5t-33 132zM176 584q0 -107 94.5 -181t235.5 -104q87 -18 151 -41q124 7 210.5 74 t86.5 184q0 112 -92 181t-282 112q-79 18 -129 37q-54 -6 -100 -22t-87 -45.5t-64.5 -79.5t-23.5 -115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA8",
    horizAdvX: 614,
    d: "M154 1294q0 23 16 39.5t39 16.5q22 0 37.5 -16.5t15.5 -39.5q0 -22 -15.5 -37.5t-37.5 -15.5q-23 0 -39 15.5t-16 37.5zM352 1294q0 23 16 39.5t38 16.5q23 0 39 -16.5t16 -39.5q0 -22 -16 -37.5t-39 -15.5q-22 0 -38 15.5t-16 37.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA9",
    horizAdvX: 1716,
    d: "M104 727q0 159 59 301.5t159.5 245t240 163t295.5 60.5t295.5 -60.5t240 -163t159.5 -245t59 -301.5t-59 -301.5t-159.5 -245t-240 -163t-295.5 -60.5t-295.5 60.5t-240 163t-159.5 245t-59 301.5zM170 727q0 -194 91 -355.5t249.5 -255t347.5 -93.5t347.5 93.5 t249.5 255t91 355.5q0 145 -54 276t-145.5 225.5t-219 150t-269.5 55.5t-269.5 -55.5t-219 -150t-145.5 -225.5t-54 -276zM481 727q0 200 109 320t276 120q141 0 236.5 -77.5t116.5 -217.5h-82q-21 106 -89 167t-182 61q-138 0 -220.5 -107t-82.5 -264q0 -161 83 -265 t214 -104q109 0 180.5 58.5t94.5 167.5h82q-31 -143 -125 -218t-242 -75q-157 0 -263 119t-106 315z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAB",
    horizAdvX: 1056,
    d: "M274 508l281 340h82l-281 -340l281 -340h-82zM547 508l280 340h82l-280 -340l280 -340h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAC",
    d: "M184 696v62h727v-328h-63v266h-664z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAD",
    horizAdvX: 561,
    d: "M66 547v61h430v-61h-430z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAE",
    horizAdvX: 1062,
    d: "M100 1137q0 188 120.5 308t309.5 120t310 -120t121 -308q0 -190 -121 -311t-310 -121t-309.5 121t-120.5 311zM162 1137q0 -165 103 -271t265 -106q164 0 267.5 106t103.5 271q0 163 -103.5 267.5t-267.5 104.5q-162 0 -265 -104.5t-103 -267.5zM403 934v418h113 q31 0 49 -2q56 -6 88.5 -35.5t32.5 -83.5q0 -39 -22.5 -66.5t-61.5 -38.5q45 -14 55 -82q11 -70 35 -110h-67q-17 43 -27 100q-6 60 -63 60h-74v-160h-58zM461 1143h53q33 0 45 2q29 5 47.5 24.5t18.5 51.5q0 66 -66 77q-12 2 -33 2h-65v-157z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAF",
    horizAdvX: 614,
    d: "M139 1262v59h338v-59h-338z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB0",
    horizAdvX: 577,
    d: "M70 1227q0 95 61.5 155t157.5 60t157.5 -60t61.5 -155t-62 -156t-157 -61t-157 61t-62 156zM137 1227q0 -70 42 -113t110 -43t109.5 43t41.5 113q0 69 -41.5 111t-109.5 42t-110 -42t-42 -111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB1",
    d: "M119 0v61h829v-61h-829zM119 621v61h383v412h63v-412h383v-61h-383v-414h-63v414h-383z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB4",
    horizAdvX: 614,
    d: "M272 1188l123 225h84l-149 -225h-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB6",
    horizAdvX: 1101,
    d: "M100 1034q0 153 85.5 260.5t236.5 116.5q35 2 115 2h417v-1638h-63v1577h-244v-1577h-63v880h-47q-80 0 -115 2q-151 9 -236.5 116.5t-85.5 260.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB7",
    horizAdvX: 313,
    d: "M88 625q0 31 19 50t49 19q31 0 50 -19t19 -50q0 -30 -19.5 -50t-49.5 -20q-29 0 -48.5 20.5t-19.5 49.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB8",
    horizAdvX: 614,
    d: "M139 -354q45 -23 109 -23q70 0 110.5 30t40.5 87q0 124 -200 115l84 161h65l-61 -114q176 -19 176 -162q0 -83 -62.5 -126.5t-154.5 -43.5q-66 0 -107 20v56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBB",
    horizAdvX: 1056,
    d: "M147 168l281 340l-281 340h82l281 -340l-281 -340h-82zM420 168l280 340l-280 340h82l280 -340l-280 -340h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBF",
    horizAdvX: 976,
    d: "M145 4q0 200 197 391q86 83 128.5 144.5t58 122t16.5 155.5h73q-3 -153 -41 -238.5t-167 -216.5q-95 -98 -137 -180.5t-42 -177.5q0 -140 86 -220.5t230 -80.5q157 0 249.5 97t104.5 266h80q-8 -193 -128 -312t-308 -119q-189 0 -294.5 104t-105.5 265zM516 1042 q0 27 18.5 45.5t45.5 18.5q28 0 45.5 -18t17.5 -46q0 -27 -18 -45t-45 -18q-26 0 -45 18.5t-19 44.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC0",
    horizAdvX: 1273,
    d: "M70 0l538 1413h103l532 -1413h-84l-203 539h-604l-198 -539h-84zM379 606h553l-275 744zM498 1700h84l108 -193h-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC1",
    horizAdvX: 1273,
    d: "M70 0l538 1413h103l532 -1413h-84l-203 539h-604l-198 -539h-84zM379 606h553l-275 744zM625 1507l108 193h84l-135 -193h-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC2",
    horizAdvX: 1273,
    d: "M70 0l538 1413h103l532 -1413h-84l-203 539h-604l-198 -539h-84zM379 606h553l-275 744zM494 1507l135 193h65l133 -193h-71l-97 152l-96 -152h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC3",
    horizAdvX: 1273,
    d: "M70 0l538 1413h103l532 -1413h-84l-203 539h-604l-198 -539h-84zM379 606h553l-275 744zM471 1559q0 100 82 100q37 0 119 -27q73 -24 94 -24q33 0 33 43h51q0 -101 -82 -101q-38 0 -121 27q-77 25 -94 25q-33 0 -33 -43h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC4",
    horizAdvX: 1273,
    d: "M70 0l538 1413h103l532 -1413h-84l-203 539h-604l-198 -539h-84zM379 606h553l-275 744zM516 1604q0 23 15.5 39t37.5 16q23 0 39.5 -16t16.5 -39q0 -22 -16.5 -38t-39.5 -16q-22 0 -37.5 16t-15.5 38zM694 1604q0 23 16.5 39t39.5 16q22 0 37.5 -16t15.5 -39 q0 -22 -15.5 -38t-37.5 -16q-23 0 -39.5 16t-16.5 38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC5",
    horizAdvX: 1273,
    d: "M70 0l538 1413h103l532 -1413h-84l-203 539h-604l-198 -539h-84zM379 606h553l-275 744zM516 1610q0 60 41 97.5t102 37.5t102.5 -37.5t41.5 -97.5t-41 -96.5t-103 -36.5q-61 0 -102 36.5t-41 96.5zM580 1610q0 -37 21 -60.5t58 -23.5t59.5 24t22.5 60t-22.5 60t-59.5 24 t-58 -23.5t-21 -60.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC6",
    horizAdvX: 1843,
    d: "M-33 0l871 1413h921v-65h-805l29 -609h729v-65h-727l29 -606h766v-68h-840l-27 539h-530l-328 -539h-88zM426 606h485l-34 740z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC7",
    horizAdvX: 1398,
    d: "M102 702q0 215 84.5 384.5t232 262.5t331.5 93q118 0 214 -35t162 -97.5t108 -144t60 -180.5l2 -20h-77l-5 20q-35 175 -156.5 282t-314.5 107q-111 0 -210.5 -45.5t-176.5 -128.5t-122.5 -211t-45.5 -282q0 -161 42.5 -289.5t116 -210.5t170.5 -125t210 -43 q205 0 327 111.5t160 295.5l5 21h77l-2 -21q-17 -99 -58.5 -181.5t-107 -148t-163 -103.5t-217.5 -42l-37 -69q176 -19 176 -162q0 -83 -62.5 -126.5t-154.5 -43.5q-66 0 -107 20v56q45 -23 109 -23q70 0 110.5 30t40.5 87q0 124 -200 115l61 118q-262 14 -422 211t-160 518 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC8",
    horizAdvX: 1157,
    d: "M199 0v1413h874v-65h-797v-609h750v-65h-750v-606h818v-68h-895zM457 1700h84l108 -193h-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC9",
    horizAdvX: 1157,
    d: "M199 0v1413h874v-65h-797v-609h750v-65h-750v-606h818v-68h-895zM584 1507l108 193h84l-135 -193h-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCA",
    horizAdvX: 1157,
    d: "M199 0v1413h874v-65h-797v-609h750v-65h-750v-606h818v-68h-895zM453 1507l135 193h65l133 -193h-71l-97 152l-96 -152h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCB",
    horizAdvX: 1157,
    d: "M199 0v1413h874v-65h-797v-609h750v-65h-750v-606h818v-68h-895zM475 1604q0 23 15.5 39t37.5 16q23 0 39.5 -16t16.5 -39q0 -22 -16.5 -38t-39.5 -16q-22 0 -37.5 16t-15.5 38zM653 1604q0 23 16.5 39t39.5 16q22 0 37.5 -16t15.5 -39q0 -22 -15.5 -38t-37.5 -16 q-23 0 -39.5 16t-16.5 38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCC",
    horizAdvX: 425,
    d: "M76 1700h84l108 -193h-57zM199 0v1413h77v-1413h-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCD",
    horizAdvX: 425,
    d: "M199 0v1413h77v-1413h-77zM203 1507l108 193h84l-135 -193h-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCE",
    horizAdvX: 425,
    d: "M72 1507l135 193h65l134 -193h-72l-96 152l-97 -152h-69zM199 0v1413h77v-1413h-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCF",
    horizAdvX: 425,
    d: "M94 1604q0 23 15.5 39t37.5 16q23 0 39.5 -16t16.5 -39q0 -22 -16.5 -38t-39.5 -16q-22 0 -37.5 16t-15.5 38zM199 0v1413h77v-1413h-77zM272 1604q0 23 16.5 39t39.5 16q22 0 37.5 -16t15.5 -39q0 -22 -15.5 -38t-37.5 -16q-23 0 -39.5 16t-16.5 38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD0",
    horizAdvX: 1411,
    d: "M82 653v60h123v700h411q103 0 158 -4q78 -7 153 -34t149.5 -82t130.5 -132t91 -192t35 -254q0 -137 -34.5 -253.5t-89.5 -194.5t-127.5 -135.5t-144 -86t-142.5 -37.5q-72 -8 -181 -8h-409v653h-123zM283 68h329q95 0 174 10q70 9 135.5 38.5t125.5 83t104.5 125.5 t71 173t26.5 217q0 119 -28.5 220t-75.5 171t-110 121t-130 77.5t-137 34.5q-52 7 -154 7h-331v-633h352v-60h-352v-585z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD1",
    horizAdvX: 1345,
    d: "M199 0v1413h118l807 -1339q-4 184 -4 588v751h76l2 -1413h-121l-805 1339q4 -184 4 -585v-754h-77zM510 1559q0 100 82 100q36 0 119 -27q73 -24 94 -24q33 0 33 43h51q0 -101 -82 -101q-39 0 -121 27q-77 25 -94 25q-33 0 -33 -43h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD2",
    horizAdvX: 1472,
    d: "M102 707q0 212 78.5 378.5t226.5 261.5t343 95q194 0 341.5 -95t225.5 -261.5t78 -378.5t-78 -378.5t-225.5 -262t-341.5 -95.5q-195 0 -343 95.5t-226.5 262t-78.5 378.5zM188 707q0 -155 44 -282.5t120.5 -211t178.5 -129t219 -45.5q116 0 217.5 45.5t177.5 129 t120 211t44 282.5q0 156 -44 283.5t-120 210.5t-177.5 128t-217.5 45q-117 0 -219 -45t-178.5 -128t-120.5 -210.5t-44 -283.5zM588 1700h84l108 -193h-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD3",
    horizAdvX: 1472,
    d: "M102 707q0 212 78.5 378.5t226.5 261.5t343 95q194 0 341.5 -95t225.5 -261.5t78 -378.5t-78 -378.5t-225.5 -262t-341.5 -95.5q-195 0 -343 95.5t-226.5 262t-78.5 378.5zM188 707q0 -155 44 -282.5t120.5 -211t178.5 -129t219 -45.5q116 0 217.5 45.5t177.5 129 t120 211t44 282.5q0 156 -44 283.5t-120 210.5t-177.5 128t-217.5 45q-117 0 -219 -45t-178.5 -128t-120.5 -210.5t-44 -283.5zM715 1507l108 193h84l-135 -193h-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD4",
    horizAdvX: 1472,
    d: "M102 707q0 212 78.5 378.5t226.5 261.5t343 95q194 0 341.5 -95t225.5 -261.5t78 -378.5t-78 -378.5t-225.5 -262t-341.5 -95.5q-195 0 -343 95.5t-226.5 262t-78.5 378.5zM188 707q0 -155 44 -282.5t120.5 -211t178.5 -129t219 -45.5q116 0 217.5 45.5t177.5 129 t120 211t44 282.5q0 156 -44 283.5t-120 210.5t-177.5 128t-217.5 45q-117 0 -219 -45t-178.5 -128t-120.5 -210.5t-44 -283.5zM584 1507l135 193h65l134 -193h-72l-96 152l-97 -152h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD5",
    horizAdvX: 1472,
    d: "M102 707q0 212 78.5 378.5t226.5 261.5t343 95q194 0 341.5 -95t225.5 -261.5t78 -378.5t-78 -378.5t-225.5 -262t-341.5 -95.5q-195 0 -343 95.5t-226.5 262t-78.5 378.5zM188 707q0 -155 44 -282.5t120.5 -211t178.5 -129t219 -45.5q116 0 217.5 45.5t177.5 129 t120 211t44 282.5q0 156 -44 283.5t-120 210.5t-177.5 128t-217.5 45q-117 0 -219 -45t-178.5 -128t-120.5 -210.5t-44 -283.5zM561 1559q0 100 82 100q37 0 119 -27q74 -24 94 -24q33 0 33 43h51q0 -101 -82 -101q-38 0 -121 27q-77 25 -94 25q-33 0 -33 -43h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD6",
    horizAdvX: 1472,
    d: "M102 707q0 212 78.5 378.5t226.5 261.5t343 95q194 0 341.5 -95t225.5 -261.5t78 -378.5t-78 -378.5t-225.5 -262t-341.5 -95.5q-195 0 -343 95.5t-226.5 262t-78.5 378.5zM188 707q0 -155 44 -282.5t120.5 -211t178.5 -129t219 -45.5q116 0 217.5 45.5t177.5 129 t120 211t44 282.5q0 156 -44 283.5t-120 210.5t-177.5 128t-217.5 45q-117 0 -219 -45t-178.5 -128t-120.5 -210.5t-44 -283.5zM606 1604q0 23 15.5 39t37.5 16q23 0 39.5 -16t16.5 -39q0 -22 -16.5 -38t-39.5 -16q-22 0 -37.5 16t-15.5 38zM784 1604q0 23 16.5 39t39.5 16 q22 0 37.5 -16t15.5 -39q0 -22 -15.5 -38t-37.5 -16q-23 0 -39.5 16t-16.5 38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD7",
    d: "M209 340l303 303l-303 301l45 45l303 -301l301 301l45 -45l-301 -301l301 -303l-45 -45l-301 303l-303 -303z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD8",
    horizAdvX: 1476,
    d: "M94 94l142 142q-132 196 -132 471q0 212 78.5 378.5t226.5 261.5t343 95q148 0 269 -56t206 -159l137 137l43 -45l-141 -141q131 -195 131 -471q0 -212 -78 -378.5t-225.5 -262t-341.5 -95.5q-148 0 -270 56t-208 159l-135 -135zM190 707q0 -243 105 -412l876 876 q-76 98 -184.5 150.5t-234.5 52.5q-117 0 -219 -45t-178.5 -128t-120.5 -210.5t-44 -283.5zM330 242q76 -98 185 -150.5t237 -52.5q116 0 217.5 45.5t177.5 129t120 211t44 282.5q0 242 -105 411z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD9",
    horizAdvX: 1271,
    d: "M186 489v924h78v-926q0 -65 6 -127q13 -143 110.5 -232t278.5 -89q183 0 281 89t111 232q6 62 6 127v926h78v-924q0 -35 -7 -135q-13 -173 -133 -278t-336 -105q-215 0 -334 105t-132 278q-7 100 -7 135zM498 1700h84l108 -193h-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDA",
    horizAdvX: 1271,
    d: "M186 489v924h78v-926q0 -65 6 -127q13 -143 110.5 -232t278.5 -89q183 0 281 89t111 232q6 62 6 127v926h78v-924q0 -35 -7 -135q-13 -173 -133 -278t-336 -105q-215 0 -334 105t-132 278q-7 100 -7 135zM625 1507l108 193h84l-135 -193h-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDB",
    horizAdvX: 1271,
    d: "M186 489v924h78v-926q0 -65 6 -127q13 -143 110.5 -232t278.5 -89q183 0 281 89t111 232q6 62 6 127v926h78v-924q0 -35 -7 -135q-13 -173 -133 -278t-336 -105q-215 0 -334 105t-132 278q-7 100 -7 135zM494 1507l135 193h65l133 -193h-71l-97 152l-96 -152h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDC",
    horizAdvX: 1271,
    d: "M186 489v924h78v-926q0 -65 6 -127q13 -143 110.5 -232t278.5 -89q183 0 281 89t111 232q6 62 6 127v926h78v-924q0 -35 -7 -135q-13 -173 -133 -278t-336 -105q-215 0 -334 105t-132 278q-7 100 -7 135zM516 1604q0 23 15.5 39t37.5 16q23 0 39.5 -16t16.5 -39 q0 -22 -16.5 -38t-39.5 -16q-22 0 -37.5 16t-15.5 38zM694 1604q0 23 16.5 39t39.5 16q22 0 37.5 -16t15.5 -39q0 -22 -15.5 -38t-37.5 -16q-23 0 -39.5 16t-16.5 38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDD",
    horizAdvX: 1134,
    d: "M45 1413h90l455 -762l446 762h90l-501 -840v-573h-78v573zM551 1507l108 193h84l-135 -193h-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDE",
    horizAdvX: 1306,
    d: "M199 0v1413h77v-225h271q117 0 196 -10q157 -20 252 -109t95 -252q0 -167 -95.5 -262t-251.5 -115q-79 -10 -196 -10h-271v-430h-77zM276 500h271q110 0 184 10q125 16 200 91t75 216q0 133 -75 204t-200 87q-74 10 -184 10h-271v-618z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDF",
    horizAdvX: 1130,
    d: "M147 0v999q0 39 5 131q10 195 129.5 304.5t298.5 109.5q166 0 275.5 -92.5t109.5 -249.5q0 -109 -66 -211q-92 -44 -134 -85.5t-42 -98.5q0 -56 26.5 -101t96.5 -106q102 -88 148 -162.5t46 -161.5q0 -134 -98.5 -209t-267.5 -75q-115 0 -215 20v72q113 -27 213 -27 q132 0 207 57.5t75 159.5q0 66 -34 124.5t-129 146.5q-92 83 -123 136.5t-31 125.5q0 75 47.5 127t151.5 106q43 68 43 160q0 129 -85.5 203t-220.5 74q-143 0 -237.5 -92.5t-106.5 -258.5q-4 -58 -4 -120v-1006h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE0",
    horizAdvX: 1030,
    d: "M90 266q0 121 88 204.5t230 121t327 37.5h70v49q0 92 -4 137q-9 110 -79.5 168.5t-197.5 58.5q-78 0 -142.5 -27t-111 -89t-57.5 -152h-80q11 146 119.5 240t271.5 94q165 0 254 -74t101 -211q4 -53 4 -141v-352q0 -124 18 -330h-80l-14 236l-51 -109 q-55 -77 -140 -116.5t-188 -39.5q-156 0 -247 76t-91 219zM176 270q0 -111 68.5 -172t201.5 -61q158 0 258.5 113t100.5 274v139q-120 8 -230 -5t-200.5 -46.5t-144.5 -96t-54 -145.5zM332 1413h84l123 -225h-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE1",
    horizAdvX: 1030,
    d: "M90 266q0 121 88 204.5t230 121t327 37.5h70v49q0 92 -4 137q-9 110 -79.5 168.5t-197.5 58.5q-78 0 -142.5 -27t-111 -89t-57.5 -152h-80q11 146 119.5 240t271.5 94q165 0 254 -74t101 -211q4 -53 4 -141v-352q0 -124 18 -330h-80l-14 236l-51 -109 q-55 -77 -140 -116.5t-188 -39.5q-156 0 -247 76t-91 219zM176 270q0 -111 68.5 -172t201.5 -61q158 0 258.5 113t100.5 274v139q-120 8 -230 -5t-200.5 -46.5t-144.5 -96t-54 -145.5zM492 1188l122 225h84l-149 -225h-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE2",
    horizAdvX: 1030,
    d: "M90 266q0 121 88 204.5t230 121t327 37.5h70v49q0 92 -4 137q-9 110 -79.5 168.5t-197.5 58.5q-78 0 -142.5 -27t-111 -89t-57.5 -152h-80q11 146 119.5 240t271.5 94q165 0 254 -74t101 -211q4 -53 4 -141v-352q0 -124 18 -330h-80l-14 236l-51 -109 q-55 -77 -140 -116.5t-188 -39.5q-156 0 -247 76t-91 219zM176 270q0 -111 68.5 -172t201.5 -61q158 0 258.5 113t100.5 274v139q-120 8 -230 -5t-200.5 -46.5t-144.5 -96t-54 -145.5zM360 1188l136 225h65l133 -225h-69l-99 176l-98 -176h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE3",
    horizAdvX: 1030,
    d: "M90 266q0 121 88 204.5t230 121t327 37.5h70v49q0 92 -4 137q-9 110 -79.5 168.5t-197.5 58.5q-78 0 -142.5 -27t-111 -89t-57.5 -152h-80q11 146 119.5 240t271.5 94q165 0 254 -74t101 -211q4 -53 4 -141v-352q0 -124 18 -330h-80l-14 236l-51 -109 q-55 -77 -140 -116.5t-188 -39.5q-156 0 -247 76t-91 219zM176 270q0 -111 68.5 -172t201.5 -61q158 0 258.5 113t100.5 274v139q-120 8 -230 -5t-200.5 -46.5t-144.5 -96t-54 -145.5zM338 1276q0 98 82 98q40 0 119 -26q77 -25 94 -25q33 0 33 43h51q0 -98 -82 -98 q-42 0 -121 26q-70 23 -94 23q-33 0 -33 -41h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE4",
    horizAdvX: 1030,
    d: "M90 266q0 121 88 204.5t230 121t327 37.5h70v49q0 92 -4 137q-9 110 -79.5 168.5t-197.5 58.5q-78 0 -142.5 -27t-111 -89t-57.5 -152h-80q11 146 119.5 240t271.5 94q165 0 254 -74t101 -211q4 -53 4 -141v-352q0 -124 18 -330h-80l-14 236l-51 -109 q-55 -77 -140 -116.5t-188 -39.5q-156 0 -247 76t-91 219zM176 270q0 -111 68.5 -172t201.5 -61q158 0 258.5 113t100.5 274v139q-120 8 -230 -5t-200.5 -46.5t-144.5 -96t-54 -145.5zM373 1294q0 23 16 39.5t39 16.5q22 0 37.5 -16.5t15.5 -39.5q0 -22 -15.5 -37.5 t-37.5 -15.5q-23 0 -39 15.5t-16 37.5zM571 1294q0 23 16 39.5t38 16.5q23 0 39 -16.5t16 -39.5q0 -22 -16 -37.5t-39 -15.5q-22 0 -38 15.5t-16 37.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE5",
    horizAdvX: 1030,
    d: "M90 266q0 121 88 204.5t230 121t327 37.5h70v49q0 92 -4 137q-9 110 -79.5 168.5t-197.5 58.5q-78 0 -142.5 -27t-111 -89t-57.5 -152h-80q11 146 119.5 240t271.5 94q165 0 254 -74t101 -211q4 -53 4 -141v-352q0 -124 18 -330h-80l-14 236l-51 -109 q-55 -77 -140 -116.5t-188 -39.5q-156 0 -247 76t-91 219zM176 270q0 -111 68.5 -172t201.5 -61q158 0 258.5 113t100.5 274v139q-120 8 -230 -5t-200.5 -46.5t-144.5 -96t-54 -145.5zM385 1307q0 62 40 99.5t101 37.5t101.5 -37.5t40.5 -99.5t-40.5 -101t-101.5 -39 t-101 39t-40 101zM446 1307q0 -38 21.5 -63t58.5 -25t59.5 25t22.5 63t-22.5 63t-59.5 25t-58.5 -25t-21.5 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE6",
    horizAdvX: 1871,
    d: "M90 266q0 320 696 320h70v51q0 200 -78 302.5t-246 102.5q-59 0 -112 -16t-98.5 -47t-75.5 -84t-37 -121h-80q8 145 121.5 239.5t281.5 94.5q319 0 381 -279q54 133 169.5 206t258.5 73q114 0 203 -44t143 -120.5t81.5 -171.5t27.5 -203q0 -24 -4 -51h-856 q4 -126 36 -220.5t86.5 -150.5t122 -83t146.5 -27q129 0 232 76t141 223h80q-43 -177 -168.5 -271t-290.5 -94q-93 0 -176 31.5t-152.5 105.5t-99.5 183l-47 -119q-148 -201 -400 -201q-152 0 -254 75t-102 220zM176 270q0 -108 77.5 -170.5t209.5 -62.5q170 0 281.5 117.5 t111.5 304.5v59q-101 2 -198 0t-184.5 -19t-153.5 -44t-105 -74.5t-39 -110.5zM936 586h778q-4 122 -35.5 212.5t-85 142.5t-117.5 76.5t-139 24.5q-80 0 -149.5 -28t-125 -82.5t-89 -143.5t-37.5 -202z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE7",
    horizAdvX: 1064,
    d: "M61 539q0 129 40 237.5t108 180.5t158.5 111.5t191.5 39.5q178 0 295.5 -101.5t142.5 -269.5h-79q-28 145 -121.5 226t-241.5 81q-75 0 -146.5 -31t-130.5 -89.5t-95 -155.5t-36 -217q0 -127 33.5 -228t90 -162t127 -92.5t149.5 -31.5q134 0 232.5 76.5t127.5 214.5h80 q-33 -167 -154 -262t-292 -95l-37 -69q176 -19 176 -162q0 -83 -62.5 -126.5t-154.5 -43.5q-66 0 -107 20v56q45 -23 109 -23q69 0 110 30t41 87q0 124 -200 115l63 120q-185 23 -301.5 171t-116.5 393z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE8",
    horizAdvX: 1081,
    d: "M61 543q0 126 38 232.5t104 179t156 113t192 40.5q111 0 199.5 -44.5t143 -120t83.5 -171.5t29 -203q0 -24 -2 -51h-861q4 -126 39.5 -222t92 -150.5t122.5 -81.5t140 -27q130 0 232 76t140 223h80q-43 -177 -168 -271t-289 -94q-98 0 -182.5 36.5t-149.5 106.5 t-102 180.5t-37 248.5zM143 586h783q-4 120 -38 211t-88.5 143t-118 77t-134.5 25q-72 0 -141 -28.5t-127 -83t-95 -144t-41 -200.5zM369 1413h84l122 -225h-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE9",
    horizAdvX: 1081,
    d: "M61 543q0 126 38 232.5t104 179t156 113t192 40.5q111 0 199.5 -44.5t143 -120t83.5 -171.5t29 -203q0 -24 -2 -51h-861q4 -126 39.5 -222t92 -150.5t122.5 -81.5t140 -27q130 0 232 76t140 223h80q-43 -177 -168 -271t-289 -94q-98 0 -182.5 36.5t-149.5 106.5 t-102 180.5t-37 248.5zM143 586h783q-4 120 -38 211t-88.5 143t-118 77t-134.5 25q-72 0 -141 -28.5t-127 -83t-95 -144t-41 -200.5zM500 1188l123 225h84l-150 -225h-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEA",
    horizAdvX: 1081,
    d: "M61 543q0 126 38 232.5t104 179t156 113t192 40.5q111 0 199.5 -44.5t143 -120t83.5 -171.5t29 -203q0 -24 -2 -51h-861q4 -126 39.5 -222t92 -150.5t122.5 -81.5t140 -27q130 0 232 76t140 223h80q-43 -177 -168 -271t-289 -94q-98 0 -182.5 36.5t-149.5 106.5 t-102 180.5t-37 248.5zM143 586h783q-4 120 -38 211t-88.5 143t-118 77t-134.5 25q-72 0 -141 -28.5t-127 -83t-95 -144t-41 -200.5zM369 1188l135 225h65l133 -225h-69l-98 176l-99 -176h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEB",
    horizAdvX: 1081,
    d: "M61 543q0 126 38 232.5t104 179t156 113t192 40.5q111 0 199.5 -44.5t143 -120t83.5 -171.5t29 -203q0 -24 -2 -51h-861q4 -126 39.5 -222t92 -150.5t122.5 -81.5t140 -27q130 0 232 76t140 223h80q-43 -177 -168 -271t-289 -94q-98 0 -182.5 36.5t-149.5 106.5 t-102 180.5t-37 248.5zM143 586h783q-4 120 -38 211t-88.5 143t-118 77t-134.5 25q-72 0 -141 -28.5t-127 -83t-95 -144t-41 -200.5zM381 1294q0 23 16 39.5t39 16.5q22 0 37.5 -16.5t15.5 -39.5q0 -22 -15.5 -37.5t-37.5 -15.5q-23 0 -39 15.5t-16 37.5zM580 1294 q0 23 15.5 39.5t37.5 16.5q23 0 39 -16.5t16 -39.5q0 -22 -16 -37.5t-39 -15.5q-22 0 -37.5 15.5t-15.5 37.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEC",
    horizAdvX: 374,
    d: "M-10 1413h84l123 -225h-58zM147 0v1079h78v-1079h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xED",
    horizAdvX: 374,
    d: "M147 0v1079h78v-1079h-78zM152 1188l122 225h84l-149 -225h-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEE",
    horizAdvX: 374,
    d: "M20 1188l136 225h65l133 -225h-69l-99 176l-98 -176h-68zM147 0v1079h78v-1079h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEF",
    horizAdvX: 374,
    d: "M33 1294q0 23 16 39.5t39 16.5q22 0 37.5 -16.5t15.5 -39.5q0 -22 -15.5 -37.5t-37.5 -15.5q-23 0 -39 15.5t-16 37.5zM147 0v1079h78v-1079h-78zM231 1294q0 23 16 39.5t38 16.5q23 0 39 -16.5t16 -39.5q0 -22 -16 -37.5t-39 -15.5q-22 0 -38 15.5t-16 37.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF0",
    horizAdvX: 1101,
    d: "M61 526q0 259 133 423.5t349 164.5q153 0 264 -84l100 -131q-26 277 -166 426l-327 -135l-23 57l299 123q-92 70 -207 96l49 60q146 -47 232 -125l149 61l23 -57l-123 -51q193 -214 193 -725q0 -170 -35.5 -297.5t-101.5 -205t-152.5 -116t-194.5 -39.5 q-215 -1 -338 154.5t-123 400.5zM147 532q0 -233 107.5 -364t275.5 -131q182 0 286 143.5t104 399.5v43q0 195 -104.5 310.5t-266.5 115.5q-112 0 -202 -59t-145 -178t-55 -280z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF1",
    horizAdvX: 1118,
    d: "M147 0v1079h78v-231l49 113q118 147 324 147q166 0 263 -86.5t112 -241.5q8 -73 8 -178v-602h-78v584q0 101 -8 174q-14 132 -89 207t-216 75q-73 0 -137.5 -26.5t-116 -78t-81.5 -138.5t-30 -199v-598h-78zM371 1276q0 98 82 98q39 0 118 -26q77 -25 95 -25q32 0 32 43 h52q0 -98 -82 -98q-42 0 -121 26q-70 23 -94 23q-33 0 -33 -41h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF2",
    horizAdvX: 1150,
    d: "M61 539q0 254 139 411.5t375 157.5t375.5 -157.5t139.5 -411.5q0 -253 -139.5 -410.5t-375.5 -157.5t-375 157.5t-139 410.5zM147 539q0 -122 34.5 -219t94 -158t136 -93t163.5 -32t164 32t137 93t95 158.5t35 218.5q0 122 -35 219.5t-95 158.5t-137 93t-164 32 t-163.5 -32t-136 -93t-94 -158.5t-34.5 -219.5zM410 1413h84l122 -225h-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF3",
    horizAdvX: 1150,
    d: "M61 539q0 254 139 411.5t375 157.5t375.5 -157.5t139.5 -411.5q0 -253 -139.5 -410.5t-375.5 -157.5t-375 157.5t-139 410.5zM147 539q0 -122 34.5 -219t94 -158t136 -93t163.5 -32t164 32t137 93t95 158.5t35 218.5q0 122 -35 219.5t-95 158.5t-137 93t-164 32 t-163.5 -32t-136 -93t-94 -158.5t-34.5 -219.5zM541 1188l123 225h84l-150 -225h-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF4",
    horizAdvX: 1150,
    d: "M61 539q0 254 139 411.5t375 157.5t375.5 -157.5t139.5 -411.5q0 -253 -139.5 -410.5t-375.5 -157.5t-375 157.5t-139 410.5zM147 539q0 -122 34.5 -219t94 -158t136 -93t163.5 -32t164 32t137 93t95 158.5t35 218.5q0 122 -35 219.5t-95 158.5t-137 93t-164 32 t-163.5 -32t-136 -93t-94 -158.5t-34.5 -219.5zM410 1188l135 225h65l133 -225h-69l-99 176l-98 -176h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF5",
    horizAdvX: 1150,
    d: "M61 539q0 254 139 411.5t375 157.5t375.5 -157.5t139.5 -411.5q0 -253 -139.5 -410.5t-375.5 -157.5t-375 157.5t-139 410.5zM147 539q0 -122 34.5 -219t94 -158t136 -93t163.5 -32t164 32t137 93t95 158.5t35 218.5q0 122 -35 219.5t-95 158.5t-137 93t-164 32 t-163.5 -32t-136 -93t-94 -158.5t-34.5 -219.5zM387 1276q0 98 82 98q40 0 119 -26q77 -25 94 -25q33 0 33 43h51q0 -98 -82 -98q-42 0 -121 26q-70 23 -94 23q-33 0 -33 -41h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF6",
    horizAdvX: 1150,
    d: "M61 539q0 254 139 411.5t375 157.5t375.5 -157.5t139.5 -411.5q0 -253 -139.5 -410.5t-375.5 -157.5t-375 157.5t-139 410.5zM147 539q0 -122 34.5 -219t94 -158t136 -93t163.5 -32t164 32t137 93t95 158.5t35 218.5q0 122 -35 219.5t-95 158.5t-137 93t-164 32 t-163.5 -32t-136 -93t-94 -158.5t-34.5 -219.5zM422 1294q0 23 16 39.5t39 16.5q22 0 37.5 -16.5t15.5 -39.5q0 -22 -15.5 -37.5t-37.5 -15.5q-23 0 -39 15.5t-16 37.5zM621 1294q0 23 15.5 39.5t37.5 16.5q23 0 39 -16.5t16 -39.5q0 -22 -16 -37.5t-39 -15.5 q-22 0 -37.5 15.5t-15.5 37.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF7",
    d: "M141 621v61h830v-61h-830zM487 330q0 29 20 48t50 19q29 0 48.5 -19t19.5 -48t-19.5 -49.5t-48.5 -20.5t-49.5 20.5t-20.5 49.5zM487 969q0 30 20 49.5t50 19.5q29 0 48.5 -19t19.5 -50q0 -29 -19.5 -48.5t-48.5 -19.5t-49.5 19.5t-20.5 48.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF8",
    horizAdvX: 1230,
    d: "M53 23l146 145q-109 149 -109 371q0 254 139 411.5t375 157.5q232 0 377 -158l152 152l45 -45l-158 -158q98 -149 98 -360q0 -253 -139 -410.5t-375 -157.5q-225 0 -364 148l-142 -142zM176 539q0 -183 80 -314l670 670q-59 72 -142.5 109.5t-179.5 37.5 q-87 0 -163.5 -32t-136 -93t-94 -158.5t-34.5 -219.5zM295 174q119 -137 309 -137q88 0 165 32t136.5 93t94 158t34.5 219q0 180 -71 303z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF9",
    d: "M129 469v610h78v-590q0 -97 8 -170q16 -131 92.5 -205.5t214.5 -74.5q154 0 258.5 112.5t104.5 329.5v598h78v-1079h-78v231l-49 -112q-124 -148 -324 -148q-162 0 -259 84.5t-116 233.5q-8 73 -8 180zM356 1413h84l123 -225h-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFA",
    d: "M129 469v610h78v-590q0 -97 8 -170q16 -131 92.5 -205.5t214.5 -74.5q154 0 258.5 112.5t104.5 329.5v598h78v-1079h-78v231l-49 -112q-124 -148 -324 -148q-162 0 -259 84.5t-116 233.5q-8 73 -8 180zM510 1188l123 225h84l-150 -225h-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFB",
    d: "M129 469v610h78v-590q0 -97 8 -170q16 -131 92.5 -205.5t214.5 -74.5q154 0 258.5 112.5t104.5 329.5v598h78v-1079h-78v231l-49 -112q-124 -148 -324 -148q-162 0 -259 84.5t-116 233.5q-8 73 -8 180zM379 1188l135 225h66l133 -225h-70l-98 176l-99 -176h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFC",
    d: "M129 469v610h78v-590q0 -97 8 -170q16 -131 92.5 -205.5t214.5 -74.5q154 0 258.5 112.5t104.5 329.5v598h78v-1079h-78v231l-49 -112q-124 -148 -324 -148q-162 0 -259 84.5t-116 233.5q-8 73 -8 180zM391 1294q0 23 16 39.5t39 16.5q22 0 38 -16.5t16 -39.5 q0 -22 -16 -37.5t-38 -15.5q-23 0 -39 15.5t-16 37.5zM590 1294q0 23 15.5 39.5t37.5 16.5q23 0 39 -16.5t16 -39.5q0 -22 -16 -37.5t-39 -15.5q-22 0 -37.5 15.5t-15.5 37.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFD",
    horizAdvX: 964,
    d: "M20 1079h89l376 -1018l377 1018h88l-424 -1102q-48 -126 -91.5 -207.5t-87.5 -124.5t-84.5 -59t-94.5 -16q-42 0 -76 6v68q27 -6 76 -6q71 0 129.5 56t118.5 202l30 77zM451 1188l122 225h84l-149 -225h-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFE",
    horizAdvX: 1148,
    d: "M147 -401v1906h78v-653l64 121q65 72 142.5 103.5t182.5 31.5q215 0 344 -155.5t129 -401.5q0 -141 -40.5 -253.5t-110 -182.5t-158.5 -107t-190 -37q-187 0 -301 123l-62 127v-622h-78zM225 475q0 -96 22 -173t57.5 -125.5t84 -81t97.5 -45.5t102 -13q183 0 298 138 t115 364q0 140 -44 252t-135 181.5t-216 69.5q-80 0 -146.5 -24.5t-120.5 -76.5t-84 -143.5t-30 -215.5v-107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFF",
    horizAdvX: 964,
    d: "M20 1079h89l376 -1018l377 1018h88l-424 -1102q-48 -126 -91.5 -207.5t-87.5 -124.5t-84.5 -59t-94.5 -16q-42 0 -76 6v68q27 -6 76 -6q71 0 129.5 56t118.5 202l30 77zM332 1294q0 23 16 39.5t39 16.5q22 0 37.5 -16.5t15.5 -39.5q0 -22 -15.5 -37.5t-37.5 -15.5 q-23 0 -39 15.5t-16 37.5zM530 1294q0 23 16 39.5t38 16.5q23 0 39 -16.5t16 -39.5q0 -22 -16 -37.5t-39 -15.5q-22 0 -38 15.5t-16 37.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0152",
    horizAdvX: 2267,
    d: "M102 707q0 211 78 377.5t224.5 262t338.5 95.5q171 0 284.5 -58t219.5 -198l62 -162v389h874v-65h-797v-609h750v-65h-750v-606h818v-68h-895v387l-62 -156q-94 -136 -216.5 -198t-287.5 -62q-191 0 -338 97t-225 263.5t-78 375.5zM188 707q0 -154 44 -281t120.5 -211 t178.5 -130t219 -46q249 0 404 179t155 489q0 155 -41.5 281.5t-115.5 210.5t-177 129.5t-225 45.5q-117 0 -219 -45.5t-178.5 -129t-120.5 -211t-44 -281.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0153",
    horizAdvX: 2025,
    d: "M61 539q0 254 139 411.5t375 157.5q173 0 298 -90.5t176 -257.5q50 166 171 257t275 91q111 0 200 -44.5t143.5 -120t83 -171t28.5 -203.5q0 -24 -4 -51h-856q4 -125 38.5 -220.5t90.5 -150.5t122.5 -82.5t139.5 -27.5q129 0 231.5 76t140.5 223h80q-43 -177 -168 -271 t-290 -94q-150 0 -267 87.5t-166 258.5q-51 -166 -173.5 -256t-293.5 -90q-236 0 -375 157.5t-139 410.5zM147 539q0 -122 34.5 -219t94 -158t136 -93t163.5 -32t164 32t137 93t95 158.5t35 218.5q0 122 -35 219.5t-95 158.5t-137 93t-164 32t-163.5 -32t-136 -93 t-94 -158.5t-34.5 -219.5zM1090 586h780q-3 98 -26.5 176.5t-59.5 129.5t-84.5 85.5t-100 49.5t-108.5 15q-73 0 -141.5 -28t-125.5 -82.5t-93.5 -144t-40.5 -201.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0178",
    horizAdvX: 1134,
    d: "M45 1413h90l455 -762l446 762h90l-501 -840v-573h-78v573zM442 1604q0 23 16 39t38 16q23 0 39 -16t16 -39q0 -22 -16 -38t-39 -16q-22 0 -38 16t-16 38zM621 1604q0 23 16 39t39 16q22 0 37.5 -16t15.5 -39q0 -22 -15.5 -38t-37.5 -16q-23 0 -39 16t-16 38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02C6",
    horizAdvX: 614,
    d: "M141 1188l135 225h66l133 -225h-69l-99 176l-98 -176h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02DC",
    horizAdvX: 614,
    d: "M119 1276q0 98 82 98q39 0 118 -26q77 -25 95 -25q32 0 32 43h52q0 -98 -82 -98q-42 0 -121 26q-70 23 -94 23q-33 0 -33 -41h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2000",
    horizAdvX: 872
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2001",
    horizAdvX: 1745
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2002",
    horizAdvX: 872
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2003",
    horizAdvX: 1745
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2004",
    horizAdvX: 581
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2005",
    horizAdvX: 436
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2006",
    horizAdvX: 290
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2007",
    horizAdvX: 290
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2008",
    horizAdvX: 218
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2009",
    horizAdvX: 349
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u200A",
    horizAdvX: 96
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2010",
    horizAdvX: 561,
    d: "M66 547v61h430v-61h-430z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2011",
    horizAdvX: 561,
    d: "M66 547v61h430v-61h-430z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2012",
    horizAdvX: 561,
    d: "M66 547v61h430v-61h-430z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2013",
    horizAdvX: 1024,
    d: "M143 565v62h738v-62h-738z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2014",
    horizAdvX: 2048,
    d: "M143 565v62h1762v-62h-1762z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2018",
    horizAdvX: 301,
    d: "M49 1016l162 489h70l-148 -501h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2019",
    horizAdvX: 301,
    d: "M20 1004l148 501h84v-12l-162 -489h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201A",
    horizAdvX: 344,
    d: "M-18 -240l110 328h82l2 -12l-125 -316h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201C",
    horizAdvX: 526,
    d: "M49 1016l162 491h70l-148 -503h-82zM274 1016l162 491h70l-148 -503h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201D",
    horizAdvX: 526,
    d: "M20 1004l148 501h84v-12l-162 -489h-70zM246 1004l147 501h84v-12l-162 -489h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201E",
    horizAdvX: 538,
    d: "M-18 -240l110 328h82l2 -12l-125 -316h-69zM176 -240l111 328h82l2 -12l-125 -316h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2022",
    horizAdvX: 454,
    d: "M104 625q0 53 35 88t88 35t88 -35t35 -88t-35 -88t-88 -35t-88 35t-35 88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2026",
    horizAdvX: 856,
    d: "M80 35q0 27 18 45t45 18q28 0 46 -17.5t18 -45.5t-18 -46t-46 -18q-27 0 -45 18.5t-18 45.5zM336 35q0 27 18 45t45 18q28 0 46 -17.5t18 -45.5t-18 -46t-46 -18q-27 0 -45 18.5t-18 45.5zM592 35q0 27 18 45t45 18q28 0 46 -17.5t18 -45.5t-18 -46t-46 -18 q-27 0 -45 18.5t-18 45.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u202F",
    horizAdvX: 349
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2039",
    horizAdvX: 784,
    d: "M274 508l281 340h82l-281 -340l281 -340h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u203A",
    horizAdvX: 784,
    d: "M147 168l281 340l-281 340h82l281 -340l-281 -340h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u205F",
    horizAdvX: 436
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u20AC",
    d: "M10 563l21 62h123l-2 75q0 59 2 88h-97l21 62h82q31 292 180 442t375 150q114 0 192.5 -29t141.5 -94l-43 -55q-59 60 -128 85t-167 25q-86 0 -160.5 -28.5t-139 -88.5t-108.5 -164t-59 -243h721l-23 -62h-702q-2 -27 -2 -79q0 -57 2 -84h653l-19 -62h-630 q47 -524 471 -524q162 0 291 82v-74q-133 -76 -301 -76q-245 0 -384 143.5t-163 448.5h-148z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2122",
    horizAdvX: 1071,
    d: "M47 1303v49h393v-49h-166v-369h-59v369h-168zM494 934v416h86l131 -365l131 365h82v-416h-56l4 356l-131 -350h-63l-129 348l2 -354h-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u25FC",
    horizAdvX: 1075,
    d: "M0 0v1075h1075v-1075h-1075z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "U",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "U",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "U",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "U",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "U",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "U",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "U",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 170
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "z",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "period,ellipsis",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "J",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla",
    g2: "T",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,uniFB02",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,uniFB02",
    g2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "T",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "Y,Yacute,Ydieresis",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,oe",
    g2: "x",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,oe",
    g2: "y,yacute,ydieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "T",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "Y,Yacute,Ydieresis",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "V",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "W",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "Z",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "period,ellipsis",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "T",
    k: 301
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "Y,Yacute,Ydieresis",
    k: 287
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "V",
    k: 254
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "W",
    k: 170
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "T",
    k: 168
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "v",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "Y,Yacute,Ydieresis",
    k: 158
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "y,yacute,ydieresis",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "V",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "W",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "quoteright,quotedblright",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "S",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "w",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "u,ugrave,uacute,ucircumflex,udieresis",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 121
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "m,n,p,r,ntilde",
    k: 127
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "b,h,k,thorn",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: -2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "J",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn",
    g2: "x",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 35
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAileronThinWebfont);
export default __webpack_public_path__ + "static/media/aileron-thin-webfont.26098af0ba0f3f9491044edd355b2ce0.svg";
export { ForwardRef as ReactComponent };